import React from "react";
import { motion } from "framer-motion";
import { Instagram, ArrowUpRight, Mail, MessageCircle } from "lucide-react";

const BG = "/amme/dining.jpg";

export const CTA = ({ t }) => {
  return (
    <section
      data-testid="cta-section"
      className="relative py-32 md:py-48 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${BG})` }}
        />
        <div className="absolute inset-0 bg-stone-900/80" />
        <div className="absolute inset-0 grain-overlay opacity-25 pointer-events-none" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-[11px] uppercase tracking-[0.4em] text-stone-400 mb-8"
        >
          — {t.cta.label}
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-4xl md:text-6xl lg:text-7xl font-light text-[#e7e7e5] leading-[1.05] tracking-tight"
        >
          {t.cta.heading}
          <br />
          <span className="italic text-stone-300">{t.cta.headingItalic}</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="mt-10 text-stone-300 text-base md:text-lg font-light leading-[1.8] max-w-xl mx-auto"
        >
          {t.cta.body}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.5 }}
          className="mt-14 flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-5 items-center justify-center"
        >
          <a
            href="https://www.instagram.com/amme.estate"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-instagram-btn"
            className="group inline-flex items-center gap-3 bg-[#e7e7e5] text-stone-900 px-8 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-[#a7a7a5] transition-colors duration-500 min-w-[260px] justify-center"
          >
            <Instagram size={16} strokeWidth={1.5} />
            <span>{t.cta.instagram}</span>
            <ArrowUpRight
              size={16}
              strokeWidth={1.5}
              className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            />
          </a>

          <a
            href="https://wa.me/13102002030"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-btn"
            className="group inline-flex items-center gap-3 border border-stone-400/60 text-[#e7e7e5] px-8 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-[#e7e7e5] hover:text-stone-900 transition-colors duration-500 min-w-[260px] justify-center"
          >
            <MessageCircle size={16} strokeWidth={1.5} />
            <span>{t.cta.whatsapp}</span>
            <ArrowUpRight
              size={16}
              strokeWidth={1.5}
              className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            />
          </a>

          <a
            href="mailto:info@ammeestate.com"
            data-testid="cta-email-btn"
            className="group inline-flex items-center gap-3 border border-stone-400/60 text-[#e7e7e5] px-8 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-[#e7e7e5] hover:text-stone-900 transition-colors duration-500 min-w-[260px] justify-center"
          >
            <Mail size={16} strokeWidth={1.5} />
            <span>{t.cta.email}</span>
            <ArrowUpRight
              size={16}
              strokeWidth={1.5}
              className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
